import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgWizardService } from 'ng-wizard';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { CKEditor4 } from "ckeditor4-angular/ckeditor";
import { logWarnings } from 'protractor/built/driverProviders';

@Component({
  selector: 'app-add-apptakeover',
  templateUrl: './add-apptakeover.component.html',
  styleUrls: ['./add-apptakeover.component.scss']
})
export class AddApptakeoverComponent implements OnInit {

  isUserwhitelisted : boolean = false;
  formGroup:any;
  localData:any;
  minDate: any;
  submitted : any;

  editorConfig = {
    toolbarGroups: [
      { name: "clipboard", groups: ["clipboard", "undo"] },
      { name: "editing", groups: ["find", "selection", "spellchecker"] },
      { name: "links" },
      { name: "insert" },
      { name: "document", groups: ["mode", "document", "doctools"] },
      { name: "basicstyles", groups: ["basicstyles", "cleanup"] },
      { name: "paragraph", groups: ["list", "indent", "blocks", "align"] },
      { name: "styles" },
      { name: "colors" },
    ],
    skin: "kama",
    resize_enabled: false,
    removePlugins: "elementspath,save,magicline",
    extraPlugins: "divarea,smiley,justify,indentblock,colordialog",
    colorButton_foreStyle: {
      element: "font",
      attributes: { color: "#(color)" },
    },
    height: 188,
    versionCheck : false,
    removeDialogTabs: "image:advanced;link:advanced",
    removeButtons: "Subscript,Superscript,Anchor,Source,Table",
    format_tags: "p;h1;h2;h3;pre;div",
  };

  selectedFile: File | null = null;
  imageBase64: string | null = null;
  roleTypes:any = [];
  imagePreview : string | null = null;

  @Input() configId = "";
  @Output() configCreated: EventEmitter<boolean> = new EventEmitter;
  @Output() getConfigId: EventEmitter<number> = new EventEmitter;
  @Output() getConfigTypeId: EventEmitter<number> = new EventEmitter;
  @Output() whitelist_obj: EventEmitter<object> = new EventEmitter;

  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private toast: ToastClientService
  ) {
    this.localData = JSON.parse(localStorage.getItem('appTakeoverList'))
    console.log(this.localData);
    
    const today = new Date();
    this.minDate = today.toISOString().split('T')[0];
   }

  ngOnInit() {
    this.form();
    this.getRoleTypes();
    if(this.localData.is_edit == true){
      console.log("hey you");
      
      this.getAppTakeoverData()
      this.whitelist_obj.emit({wts_type : this.localData.whitelisting_type })
    }
  }


  getRoleTypes(){
    this.apiService.get(this.apiConfig.configGetRoles).subscribe((res)=>{
      this.roleTypes = res['data'].filter(item => item.id == 5)
      console.log(this.roleTypes);
    })
  }



  form(data?) {
    console.log(data);
    // if(data) this.getEngagementElement(data.engagement_type_id)
    this.formGroup = this.fb.group({
      app_takeover_name: new FormControl(data ? data.configuration_name : "", []),
      start_date: new FormControl(data ? data.start_date : "", [Validators.required]),
      end_date: new FormControl(data ? data.end_date : "", [Validators.required]),
      content_type: new FormControl(data ? data.content_type : "", []),
      content_image: new FormControl(data ? data.image : "", [Validators.required]),
      content_video: new FormControl(data ? data.content : "", [Validators.required]),
      content : new FormControl(data ? data.content : "", [Validators.required]),
      sequence: new FormControl(data ? data.sequence : "", [Validators.required]),
      frequency: new FormControl(data ? data.frequency : "", [Validators.required]),
      whitelisting_type : new FormControl(data?data.whitelisting_type:"",[Validators.required]),
      // zone_type : new FormControl({ value: data ? data.zone_type :"", disabled: this.isUserwhitelisted ? true : false},[]),
      role_type : new FormControl(data?data.role_id:"",[Validators.required]),
    })
  }

  get f() {
    return this.formGroup.controls;
  }

  onImageSelected(event){
    const file = event.target.files[0];

      if (!file) {
      return;
      }

      this.selectedFile = file;

      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
      this.imageBase64 = reader.result as string;
      this.imagePreview = reader.result as string;

      this.formGroup.patchValue({
        content_image: this.imageBase64
      });
    };
  }

  getAppTakeoverData() {
    this.apiService.get(this.apiConfig.ConfigurationList + `?config_id=${this.localData.id}`).subscribe((res: any) => {
      
      // this.isUserwhitelisted = res.body.data.engagement.is_whitelisted

      // if(this.isUserwhitelisted){
      //   this.formGroup.get('whitelist_type').disable()
      //   this.formGroup.get('role_type').disable()
      // }
      this.imagePreview = res.data.data[0].image;
      setTimeout(() => {
        this.form(res.data.data[0])
        // if(res.data.data[0].image){
        //   this.formGroup.patchValue({
        //     content_image: res.data.data[0].image
        //   });
        // }
      }, 100);
    })
  }



  onSubmit(formGroup) {
    let value = formGroup.getRawValue()
    console.log("submited called")
    this.submitted = true;
    console.log(this.formGroup);
    console.log(value);
    if (this.formGroup.invalid) {
        return this.toast.Warning('Select Required Feilds')
    }

    if(value.sequence < 1){
      return this.toast.Warning('Sequence should not be less than one')
    }

    if(value.sequence > 10){
      return this.toast.Warning('Sequence should be greater than 10')
    }

    let content = '';
    console.log(value.content);
    

    switch (value.content_type) {
      case "1":
        content = value.content_image;
        break;
      case "2":
        content = value.content_video;
        break;
      case "3":
        content = value.content;
        console.log(content);
        break;
    }


    let payload = {
      configuration_name : value.app_takeover_name,
      start_date : value.start_date,
      end_date : value.end_date,
      content_type : value.content_type,
      content_image : value.content_image,
      content : content,
      sequence : value.sequence,
      frequency : value.frequency,
      whitelisting_type : value.whitelisting_type,
      // zone_type : value.zone_type,
      role_type : value.role_type
    }

    this.apiService.post(this.apiConfig.addApptakeoverConfig, payload).subscribe((res:any)=>{

      console.log(res.body.data);
      this.toast.Success("Engagement created Successfully") 
      localStorage.setItem("appTakeoverList", JSON.stringify(res.body.data.data))
      this.configCreated.emit(true)
      this.whitelist_obj.emit({wts_type : value.whitelisting_type})

    },err=>{
      this.toast.Error(err.body.data)
    })
    
  }


  contentTypeChange(e){
    console.log(e);
    if(e.target.value == '2'){
      this.formGroup.get('content_video').setValidators([Validators.required])
      this.formGroup.get('content_image').clearValidators()
      this.formGroup.get('content_image').setErrors(null);
      this.formGroup.get('content').clearValidators();
      this.formGroup.get('content').setErrors(null);
      this.formGroup.updateValueAndValidity();
    }else if(e.target.value == '1'){
      this.formGroup.get('content_image').setValidators([Validators.required])
      this.formGroup.get('content_video').clearValidators();
      this.formGroup.get('content_video').setErrors(null);
      this.formGroup.get('content').clearValidators();
      this.formGroup.get('content').setErrors(null);
      this.formGroup.updateValueAndValidity();
    }else{
      this.formGroup.get('content').setValidators([Validators.required])
      this.formGroup.get('content_image').clearValidators();
      this.formGroup.get('content_image').setErrors(null);
      this.formGroup.get('content_video').clearValidators();
      this.formGroup.get('content_video').setErrors(null);
      this.formGroup.updateValueAndValidity();
    }
  }
}
